<app-header></app-header>
<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="text-center">
          <div class="forgotdiv">
            <form [formGroup]="form" (ngSubmit)="UpdatePassword(form)">
              <h2 class="mb-4">Forgot Password</h2>

              <div class="mb-3">
                <div class="form-check form-check-inline">
                  <input type="radio" id="rdbtnmsme" value="MSME" formControlName="signinas" (change)="onSignInAsChange($event)" class="form-check-input">
                  <label for="rdbtnmsme" class="form-check-label">MSME</label>
                </div>
                <div class="form-check form-check-inline">
                  <input type="radio" id="rdbtnia" value="IA" formControlName="signinas" (change)="onSignInAsChange($event)" class="form-check-input">
                  <label for="rdbtnia" class="form-check-label">IA</label>
                </div>
                <div *ngIf="f['signinas'].touched && f['signinas'].invalid" class="alert alert-danger mt-2">
                  <div *ngIf="f['signinas'].errors?.['required']">Select one of the above</div>
                </div>
              </div>

              <div class="mb-3 text-start">
                <label for="txtUsername" class="form-label">
                  {{ signinas === 'MSME' ? 'MSME Username' : 'IA Username(Email ID)' }}
                </label>

                <input type="text" id="txtUsername" formControlName="username" class="form-control"
                       [placeholder]="signinas === 'MSME' ? 'UDYAM-MH-' : 'Enter your email ID'"
                       autocomplete="off"
                       [attr.maxlength]="signinas === 'MSME' ? 19 : 50">  <!-- Set maxlength dynamically -->

                <div *ngIf="f['username'].touched && f['username'].invalid" class="alert alert-danger mt-2">
                  <div *ngIf="f['username'].errors?.['required']">Username is required</div>
                  <div *ngIf="signinas !== 'MSME' && f['username'].errors?.['email']">Enter a valid email address</div>
                  <div *ngIf="signinas === 'MSME' && f['username'].errors?.['pattern']">
                    Your UDYAM registration number is invalid. Please enter a valid UDYAM registration number.
                  </div>
                </div>
              </div>



              <!--<div class="mb-3 text-start"  *ngIf="signinas">
    <label for="txtUsername" class="form-label">Username</label>
    <input type="text" id="txtUsername" formControlName="username" class="form-control" placeholder="" autocomplete="off">
    <div *ngIf="f['username'].touched && f['username'].invalid" class="alert alert-danger mt-2">
      <div *ngIf="f['username'].errors?.['required']">Username is required</div>
    </div>
  </div>-->

              <div class="mb-3">
                <small>(OTP will be sent to your registered Mobile number & Email ID)</small>
              </div>

              <!--<div class="mb-3">
    <button type="button" id="btngenerateotp" class="btn btn-primary btn-sm" (click)="genetedOTP(form)" [disabled]="!isPasswordValid">Generate OTP</button>
  </div>-->
              <!--<div class="row text-start mb-3 mt-1">
    <div class="col-md-6">
      <button id="btnsendotp" type="button" (click)="genetedOTP(form)" [disabled]="(!this.form.controls.username.value || this.form.controls.username.invalid ) && (isButtonMobileDisabled || mobileOtpTimerRunning)" class="btn btn-primary btn-sm">Send OTP</button>

    </div>

    <div class="col-md-6 mt-1">-->
              <!--<button id="btnresendotp" type="button" (click)="ReSendMobileOTP()" [disabled]="resendMobileOtpDisabled || mobileOtpTimerRunning"  class="btn btn-primary btn-sm">-->
              <!--<button id="btnresendotp" type="button" (click)="genetedOTP(form)" [disabled]="resendMobileOtpDisabled || mobileOtpTimerRunning" class="btn btn-primary btn-sm">
        Resend OTP<span *ngIf="mobileOtpTimerRunning"> {{ mobileOtpTimer }}</span>
      </button>
    </div>
  </div>-->

              <div class="row text-start mb-3">
                <div class="col-md-6 mt-1">
                  <button id="btnsendotp"
                          type="button"
                          (click)="generateOTP(form)"
                          [disabled]="isButtonMobileDisabled || !form.controls.username.value || form.controls.username.invalid"
                          class="btn btn-primary btn-sm">
                    Send OTP
                  </button>
                </div>

                <div class="col-md-6 mt-1">
                  <button id="btnresendotp"
                          type="button"
                          (click)="generateOTP(form)"
                          [disabled]="resendMobileOtpDisabled || mobileOtpTimerRunning"
                          class="btn btn-primary btn-sm">
                    Resend OTP<span *ngIf="mobileOtpTimerRunning"> {{ mobileOtpTimer }}</span>
                  </button>
                </div>
              </div>



              <div class="row text-start mb-3">
                <label class="nowrap">Enter OTP <span class="text-danger">*</span></label>
                <div class="col-md-6">
                  <!--<input type="text" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="mobotp" (keypress)="numberOnly($event)"
         placeholder="Enter OTP" minlength="6" maxlength="6">-->
                  <input type="text"
                         autocomplete="off"
                         id="txtMobOTP"
                         class="form-control otp-input"
                         formControlName="mobotp"
                         (keypress)="numberOnly($event)"
                         placeholder="Enter OTP"
                         minlength="6"
                         maxlength="6">
                  <div *ngIf="f['mobotp'].touched && f['mobotp'].invalid" class="alert alert-danger">
                    <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['required']">
                      Please Enter otp received
                    </div>
                    <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['minLength']">
                      OTP should be of length 6 digits only
                    </div>
                    <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['maxLength']">
                      OTP should be of length 6 digits only
                    </div>
                    <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['pattern']">
                      Entered OTP is incorrect. Please enter correct OTP
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mt-1">
                  <button id="btnverifyotp" type="button" (click)="VerifyOTP()" [disabled]="f['mobotp'].invalid || !f['mobotp'].value || isVerifyMobileOtpButtonDisabled" class="btn btn-success btn-sm">Verify OTP</button>
                </div>
              </div>


              <div class="mb-3 text-start">
                <label for="txtnewpassword" class="form-label">New Password</label>
                <div class="input-group">
                  <input [type]="showNewPassword ? 'text' : 'password'" id="txtnewpassword" formControlName="newpassword" class="form-control" placeholder="New Password" maxlength="20" autocomplete="off">
                  <button type="button" class="input-group-text" (click)="toggleShowNewPassword()">
                    <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
                <div *ngIf="f['newpassword'].touched && f['newpassword'].invalid" class="alert alert-danger mt-2">
                  <div *ngIf="f['newpassword'].errors?.['required']">New password is required.</div>
                  <div *ngIf="f['newpassword'].errors?.['minlength']">Minimum length should be 8 characters.</div>
                  <div *ngIf="f['newpassword'].errors?.['pattern']">New password must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.</div>
                </div>
              </div>


              <div class="mb-3 text-start">
                <label for="txtconfirmpassword" class="form-label">Confirm New Password</label>
                <div class="input-group">
                  <input [type]="showConfirmNewPassword ? 'text' : 'password'" id="txtconfirmpassword" formControlName="confirmpassword" class="form-control" placeholder="Confirm New Password" maxlength="20" autocomplete="off" (paste)="onPaste($event)">
                  <button type="button" class="input-group-text" (click)="toggleShowConfirmNewPassword()">
                    <i class="fa" [ngClass]="showConfirmNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
                <div *ngIf="f['confirmpassword'].touched && f['confirmpassword'].invalid" class="alert alert-danger mt-2">
                  <div *ngIf="f['confirmpassword'].errors?.['required']">Confirm password is required.</div>
                  <div *ngIf="f['confirmpassword'].errors?.['minlength']">Minimum length should be 3 characters.</div>
                  <div *ngIf="form.controls.confirmpassword.touched && form.hasError('passwordMismatch')">Password and Confirm Password must match.</div>
                </div>
              </div>




              <div class="d-flex justify-content-between">
                <button type="submit" id="btnupdate" class="btn btn-success"
                        [disabled]="!form.valid || form.hasError('passwordMismatch') || !form.controls.newpassword.value || !form.controls.confirmpassword.value">
                  Update Password
                </button>
                <button type="reset" id="btncancel" class="btn btn-danger" [routerLink]="'/login'">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
